import useBusinessNavigationMenu from '@hooks/menus/use-business-navigation-menu.hook'
import DefaultSidebar from '@components/sidebars/default.sidebar'

export default function BusinessSidebar() {
    const { navigation } = useBusinessNavigationMenu()

    return (
        <DefaultSidebar navigation={navigation} />
    )
}